exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group.keyword[data-v-497c06be]{position:relative}.clear-keyword[data-v-497c06be]{position:absolute;top:2px;right:35px;z-index:9}", ""]);

// exports
